import { render, staticRenderFns } from "./main-bottom.vue?vue&type=template&id=7796cc3d&scoped=true&"
import script from "./main-bottom.vue?vue&type=script&lang=js&"
export * from "./main-bottom.vue?vue&type=script&lang=js&"
import style0 from "./main-bottom.vue?vue&type=style&index=0&id=7796cc3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796cc3d",
  null
  
)

export default component.exports